import { SelectionModel } from '@angular/cdk/collections';
import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { EventInvitation, EventInvitationStatusesList } from 'diwimamodelweb/lib';
import { BehaviorSubject } from 'rxjs';
import * as XLSX from 'xlsx';
import * as moment from 'moment'
import { TranslateService } from '@ngx-translate/core';
import { EventInviteSharedService } from 'src/app/cockpit/event-invitation/event-invite-shared.service';
import { UserFeedbackService } from '../user-feedback.service';
import { deepCopy, determineLocale } from 'diwimamodelweb/lib';
import { GenericDialogComponent } from '../generic-dialog/generic-dialog.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ObjectExportService, ExportMappings } from '../object-export.service';
import { environment } from 'src/environments/environment';
import { copyTextToClipboard } from 'src/app/cockpit/event-invitation/mng-person/mng-person.component';

export enum EventInvitationHost {
  EVENT, PERSON
}

@Component({
  selector: 'app-event-ivitation-table',
  templateUrl: './event-ivitation-table.component.html',
  styleUrls: ['./event-ivitation-table.component.scss']
})
export class EventIvitationTableComponent implements OnInit, OnChanges {

  @Input() eventInvites: EventInvitation[]
  @Input() host: EventInvitationHost
  resetEmitter = new EventEmitter<void>()
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  @Output() invitationId = new EventEmitter<string>()

  tableFilterForm: FormGroup
  filteredEventInvites$ = new BehaviorSubject(undefined)

  displayedColumns: string[]

  dataSource: MatTableDataSource<EventInvitation>
  dataSourceForExcelExport: MatTableDataSource<EventInvitation>
  selection = new SelectionModel<EventInvitation>(true, []);
  show = false
  sort: MatSort
  @ViewChild(MatSort) set matSort(m) {
    if (m) {
      setTimeout(() => {
        this.sort = m
        this.sort.sortChange.subscribe(() => this.dataSource.paginator.pageIndex = 0);
        if (this.dataSource) {
          this.dataSource.sort = this.sort
        }
      })
    }
  }
  paginatorPageSizeOptions = [25, 50, 100]
  statuses = EventInvitationStatusesList
  locale: string

  constructor(
    private translateService: TranslateService,
    private eventInviteSharedService: EventInviteSharedService,
    private userFeedbackService: UserFeedbackService,
    private formBuilder: FormBuilder,
    private objectExportService: ObjectExportService,
    private translate: TranslateService
  ) {
    this.locale = determineLocale(navigator.language)
  }

  ngOnInit(): void {
    switch (this.host) {
      case (EventInvitationHost.EVENT): {
        this.displayedColumns = [
          'personAnzeigeName',
          'personEmailAddresse', 'invitation_link', 
          'processingStatus',
          'creationDate', 'info'
        ]
        break
      }
      case (EventInvitationHost.PERSON): {
        this.displayedColumns = [
          'eventName',
          'huntingDistrictName', 'eventDate', 'processingStatus',
          'creationDate', 'info'
        ]
        break
      }
    }
    this.tableFilterForm = this.formBuilder.group({
      textFilter: [],
      statusFilter: []
    })
    this.tableFilterForm.valueChanges.subscribe((value) => {

      const { textFilter, statusFilter } = value
      this.filterTable(textFilter, statusFilter)
    })
    this.filteredEventInvites$.subscribe((invites) => {
      if (invites) {
        this.createTable(invites)
      }
    })
    // this.filteredEventInvites$.next(this.eventInvites)
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes.eventInvites) {
      this.resetEmitter.emit()
      const newData = changes.eventInvites.currentValue

      const value = this.tableFilterForm?.value

      this.filterTable(value?.textFilter, value?.statusFilter)
      // this.filteredEventInvites$.next(newData)
      // this.dataSourceForExcelExport = new MatTableDataSource(newData)
      // rebuild 

    }
  }

  createTable(data: EventInvitation[]) {
    this.show = false
    this.dataSource = new MatTableDataSource(data)
    this.dataSource.paginator = this.paginator
    this.dataSource.sort = this.sort
    this.show = true
  }

  filterTable(searchString: string | undefined, statuses: string[] | undefined) {
    // set page index to 0

    if (!searchString && (!statuses || statuses.length == 0)) {
      this.filteredEventInvites$.next(this.eventInvites)
    } else {
      let str = searchString
      if (searchString) str = searchString.toLowerCase()
      this.dataSource.paginator.pageIndex = 0
      const filtered = this.eventInvites.filter(el => {
        if (str && (statuses && statuses.length > 0)) {
          return el.searchFilter(str) && statuses?.includes(el.processingStatus)
        } else if (str && (!statuses || statuses.length == 0)) {
          return el.searchFilter(str)
        } else if (!str && statuses) {
          return statuses?.includes(el.processingStatus)
        }
      })
      this.filteredEventInvites$.next(filtered)
    }
  }

  async editStatus(element, st) {


    // edit process Status .. await result... 
    try {
      const sbSuccessSave = await this.translateService.get('changes_saved').toPromise()
      this.userFeedbackService.loading.emit(true)
      const oldInvitation = deepCopy(element, element.replacerFn)
      const newInvitation = Object.assign({}, oldInvitation, { processingStatus: st })
      await this.eventInviteSharedService.updateSingleInvitation(oldInvitation, newInvitation)
      this.userFeedbackService.loading.emit(false)
      this.userFeedbackService.showSnackBar.emit(sbSuccessSave)
      element.processingStatus = st
    } catch (error) {
      this.userFeedbackService.loading.emit(false)
      console.error(error)
      this.userFeedbackService.showDialog.emit(
        {
          entryComponent: GenericDialogComponent,
          title: "Error",
          message: error?.error?.message ? error?.error?.message : JSON.stringify(error),
        }
      )
    }
  }

  info(element) {
    this.invitationId.emit(element.identifier)
  }

  async exportToExcel() {
    // const itemCount = this.dataSource.paginator.pageSize
    // this.dataSource.paginator.pageSize = this.dataSource.data.length

    const list = this.dataSource.data
    // convert to json that converts to sheet...

    if (list.length > 0) {
      const nList = await this.objectExportService.toXlsxExport(list, ExportMappings.eventInvitationExport)

      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(nList);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();

      let exportName = await this.translateService.get('TABLE.eventInvitation.export_name').toPromise()
      exportName += `_${this.eventInvites[0].eventName}`
      const date = new Date()
      if (this.host == EventInvitationHost.PERSON) {
        exportName += this.dataSource.data[0].personAnzeigeName
      }

      const fileName = `${moment(date).format('YYYYMMDD')}_${exportName}`
      XLSX.utils.book_append_sheet(wb, ws, exportName.length > 29 ? exportName.substring(0, 29) : exportName);

      /* save to file */
      XLSX.writeFile(wb, `${fileName}.xlsx`);
      // this.dataSource.paginator.pageSize = itemCount
    } else {
      const txt = await this.translateService.get('snack_no_approved_invitations').toPromise()
      this.userFeedbackService.showSnackBar.emit(txt)
    }
  }

  async getInvitationLink(element: any) {
    try {
      await copyTextToClipboard(`${environment.invitationURL}/inv/${element.personInvitationRef}`) 
      const text = await this.translate.get('snack_success_copy').toPromise()
      this.userFeedbackService.showSnackBar.emit(text)
    } catch (error) {
      const text = await this.translate.get('snack_failure_copy').toPromise()
      this.userFeedbackService.showSnackBar.emit(text)
    }    
  }

}
